"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUploadFiles = void 0;
var useFormDataAPICallAsync_1 = require("./useFormDataAPICallAsync");
exports.useUploadFiles = function (_a) {
    var application = _a.application, category = _a.category, bearer = _a.bearer, centralUserProfile = _a.centralUserProfile, rest = __rest(_a, ["application", "category", "bearer", "centralUserProfile"]);
    var _b = useFormDataAPICallAsync_1.useFormDataAPICallAsync({
        bearer: bearer,
        centralUserProfile: centralUserProfile,
        api: {
            method: 'POST',
            endpoint: application + "/" + category,
        },
        customFields: __assign({}, rest),
    }), result = _b.result, call = _b.call;
    return {
        result: result,
        call: call,
    };
};
//# sourceMappingURL=useUploadFiles.js.map